import { useState } from 'react'
import { Settings, Wifi, WifiOff, Power } from 'lucide-react'
import { useConnection } from '@/features/connection/ConnectionContext'
import { Button } from '@/components/ui/Button'
import { SettingsModal } from '@/features/settings/SettingsModal'

export function Header() {
  const { isConnected, disconnect } = useConnection()
  const [settingsOpen, setSettingsOpen] = useState(false)

  return (
    <header className="flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-zinc-950">
      {/* Left: App title */}
      <div className="flex items-center gap-2">
        <h1 className="text-lg font-semibold text-white">E-Ink Photo Calendar</h1>
      </div>

      {/* Right: Status and actions */}
      <div className="flex items-center gap-3">
        {/* Connection status */}
        <div className="flex items-center gap-2 text-sm">
          {isConnected ? (
            <>
              <Wifi className="w-4 h-4 text-green-500" />
              <span className="text-green-500">Connected</span>
            </>
          ) : (
            <>
              <WifiOff className="w-4 h-4 text-red-500" />
              <span className="text-red-500">Disconnected</span>
            </>
          )}
        </div>

        {/* Settings button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setSettingsOpen(true)}
          aria-label="Settings"
        >
          <Settings className="w-5 h-5" />
        </Button>

        {/* Disconnect button */}
        {isConnected && (
          <Button
            variant="ghost"
            size="icon"
            onClick={disconnect}
            aria-label="Disconnect"
            className="text-red-500 hover:text-red-400"
          >
            <Power className="w-5 h-5" />
          </Button>
        )}
      </div>

      {/* Settings Modal */}
      <SettingsModal open={settingsOpen} onOpenChange={setSettingsOpen} />
    </header>
  )
}
